<template>
  <message-template :direction="'outgoing'" :time="time" :channel="channel">
    <div class="log-processing-message-block processing-bg">
      <ul class="processing-list" v-if="messageType === 'model-prediction'">
        <li>
          <span>Predict using model</span>
          <strong>{{currentModelName || data.modelId}}</strong>
        </li>
        <li v-if="data.prediction.predictionResult">
          <span class="success-text">
            Success from text&nbsp;
            "
            <strong>{{data.prediction.text}}</strong>"
            &nbsp;as&nbsp;
            "
            <strong>{{data.prediction.predictionResult}}</strong>"
          </span>
        </li>
        <li v-else>
          <span class="danger-text">
            Cannot predict message "
            <strong>{{data.prediction.text}}</strong>"
          </span>
        </li>
      </ul>
      <ul class="processing-list" v-else-if="messageType === 'rule-based-matching'">
        <li>Checking with rule-based</li>
        <li class="success-text" v-if="data.matchedRuleName">
          Match message&nbsp;
          "
          <strong>{{data.text}}</strong>"
          &nbsp;found in rule&nbsp;
          "
          <strong>{{data.matchedRuleName}}</strong>"
        </li>
        <li class="danger-text" v-else>
          No matched rule for message "
          <strong>{{data.text}}</strong>"
        </li>
      </ul>
      <strong class="danger-text" v-else-if="data.text">
        Not understand message "{{data.text}}"
      </strong>
      <span v-else>Processing ... {{data}}</span>
    </div>
  </message-template>
</template>
<script>
import MessageTemplate from './MessageTemplate.vue';

export default {
  name: 'textMessage',
  components: {
    'message-template': MessageTemplate,
  },
  props: {
    modelList: {
      type: Array,
    },
    data: {
      type: Object,
    },
    messageType: {
      type: String,
    },
    time: {
      type: Number,
      default: 0,
    },
    channel: {
      type: String,
      default: '',
    },
    uid: {
      type: String,
    },
  },
  mounted() {},
  data() {
    return {};
  },
  methods: {},
  computed: {
    currentModel() {
      if (this.modelList && this.data && this.data.modelId) {
        return this.modelList.find((model) => model.id === this.data.modelId);
      }
      return false;
    },
    currentModelName() {
      if (this.currentModel && this.currentModel.name) {
        return this.currentModel.name;
      }
      return '';
    },
  },
};
</script>
<style lang="scss" scoped>
.log-processing-message-block {
  border: 1px dashed #ddd;
  color: #888;
  padding: 10px;
  display: inline-block;
  text-align: left;
  border-radius: 10px 0 10px 10px;
  font-size: 0.9em;
  .processing-list {
    margin: 0;
    padding-inline-start: 10px;
  }
  * {
    color: #888;
  }
  .success-text,
  .success-text * {
    color: #008d00;
  }
  .danger-text,
  .danger-text * {
    color: #d73912;
  }
}
</style>
